import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('/inventory-logs', { params: params })
      .then(response => response.data)
  }
}
